import React, { useState } from 'react'
import Container from 'components/Container'
import InputString from 'components/InputString'
import { useRegisterList } from 'data/RegisterList'
import { useTranslation } from 'react-i18next'
import { useActiveWeb3React } from '../../hooks'
import AppBody from '../AppBody'
import { BottomBox, InputTitle, InputBox, DetailBtn, ArrowIcon, NoMore, ListItem, Status, 
   Title, Time, TopBox, WarnTip, ProgressBox, Progress, Bar } from './styleds'
import { LockPlatformCoin } from '../../data/LockPlatformCoin'
import bottomImg from '../../assets/images/bottom.png'
import topImg from '../../assets/images/top.png'

export default function RegisterList({match}) {
   const { lockAddress } = match.params
   const { account } = useActiveWeb3React()
   const platformCoinSymbol = LockPlatformCoin(lockAddress)
   const tokenList:any = useRegisterList(lockAddress, account ?? undefined)
   // eslint-disable-next-line no-console
   console.log(tokenList, 'tokenList---')
   const { t } = useTranslation()

   const [ show, setShow ] = useState({});
   const doSetShow = (name, value) => {
      show[name] = value
      setShow({ ...show })
    }
   const handle = (event) => {
      // eslint-disable-next-line no-console
      console.log(event)
    }

  return (
  <Container>
  
  <AppBody>
  { tokenList.length > 0 ? (tokenList.map((item:any) => (
   <ListItem key={ item.tokenAddress }>
       <TopBox>
         <div className='left'>
           <Status className={ item.isSupport ? '' : 'yellow' }>{ item.isSupport ? t('Online') : t('Not online') }</Status>
           <Title>{ item.symbol } { t('token register') }</Title>
           <Time>{ t('Application time') }:{ item.time }</Time>
         </div>
         <DetailBtn onClick={(event) => {
                  event.stopPropagation()
                   doSetShow(item.tokenAddress, !show[item.tokenAddress])
                }}>
           <span>{ t('details') }</span>
           { show[item.tokenAddress] ? <ArrowIcon src={ topImg } width='12px' height='8px'/> :(<ArrowIcon src={ bottomImg } width='12px' height='8px'/>)}
         </DetailBtn>
       </TopBox>
       { show[item.tokenAddress] ? (<BottomBox>
       <InputBox>
         <InputTitle>{ t('Register token contract address') }</InputTitle>
         <InputString readOnly value={ item.tokenAddress } onUserInput= { handle }/>
         </InputBox>
         <InputBox>
         <InputTitle>{ t('Register Token Name') }</InputTitle>
         <InputString disabled value={ item.symbol } onUserInput={ handle }/>
         </InputBox>
         <InputBox>
         <InputTitle>{ t('Application registrant wallet address') }</InputTitle>
         <InputString  disabled value={ item.principal } onUserInput={ handle }/>
         </InputBox>
          <ProgressBox>
            <Progress>
               <Bar style={{ width: `${Number(item.num * 100 /item.limit).toFixed(2)  }%` }}/>
               <div className='desc'>
               {t('Enter the number of airdrop contract addresses')} <span>{item.num}/{item.limit}</span>
               </div>
            </Progress>
          </ProgressBox>
         <WarnTip>
         { t('applyDesc2') }<br />
         { t('applyDesc', {symbol: platformCoinSymbol}) }
         </WarnTip>
         
       </BottomBox>) : <></>}
       </ListItem>))) : <NoMore>{ t('No records') }</NoMore>}
  </AppBody>
 </Container>
)}